import React from 'react';
import localStrings from "../../localStrings";
import GenericSparkDataSpark from "./GenericSparkDataSpark";
import PlateIcon from "../../icons/untitled-ui/duocolor/plate";
import {useMediaQuery} from "@mui/material";

function SeatsSpark() {
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    // Force graph mode for testing - change to md or sm for lower screen sizes
    const forceGraphMode = useMediaQuery((theme) => theme.breakpoints.up("md"));

    return (
        <GenericSparkDataSpark
            modeGraph={forceGraphMode}
            getterData={(data) => data?.nbSeats}
            title={localStrings.nbSeats}
            backgroundColor={(theme) => theme.palette.mode === 'dark'
                ? 'neutral.800'
                : 'success.lightest'}
            icon={<PlateIcon/>}
    />
)
}

export default SeatsSpark